export const COLUMN_BUFFER = 10;
export const STANDARD_LEFT_OFFSET = 45;
export const CHART_WIDTH_PADDING = 25;
export const AXIS_TITLE_SPACING = 15;
export const LABEL_CONDITION_ID = 'labelCondition';
export const CAPSULE_LANE_HEIGHT = 18;
